/**
 * This module declares the main Amplify object
 * Exports a "fake" reducer to be used in the stored for acquiring the object
 */

import { Auth, API, PubSub, Amplify } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';

const {
  REACT_APP_API_GATEWAY_URL,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  REACT_APP_COGNITO_IDENTITY_POOL_ID,
  REACT_APP_PUBSUB_REGION,
  REACT_APP_PUBSUB_ENDPOINT,
} = process.env;

const authOptions = {
  Auth: {
    region: REACT_APP_COGNITO_REGION,
    userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    identityPoolId: REACT_APP_COGNITO_IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: 'IO_API',
        endpoint: REACT_APP_API_GATEWAY_URL,
        custom_header: async () => {
          try {
            return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` };
          } catch (e) {
            console.error('Failed to set the API authentication', e);
            return {};
          }
        },
      },
    ],
  },
};

Amplify.configure(authOptions);
Auth.configure();
Amplify.Logger.LOG_LEVEL = process.env.NODE_ENV === 'development' ? 'DEBUG' : '';

Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: REACT_APP_PUBSUB_REGION,
    aws_pubsub_endpoint: REACT_APP_PUBSUB_ENDPOINT,
  }),
);

export { API, PubSub, Auth };
